const PaymentActionTypes = {
    UPDATE_LAST_DATE_PAID_START: 'UPDATE_LAST_DATE_PAID_START',
    UPDATE_LAST_DATE_PAID_SUCCESS: 'UPDATE_LAST_DATE_PAID_SUCCESS',
    UPDATE_LAST_DATE_PAID_FAILURE: 'UPDATE_LAST_DATE_PAID_FAILURE'
};

export default PaymentActionTypes;